import { Injectable, Output } from "@angular/core";
import { Subject } from "rxjs";
import * as jp from "jsonpath/jsonpath";

export interface AlteredContextEvent{
    target: string;
    value: any;
}

@Injectable({
    providedIn: 'root'
})
export class ContextInteractionService {

    contextTargetHasBeenSet = new Subject<AlteredContextEvent>();

    constructor() { }

    getContextData(target: string, context: any): any {
        return jp.value(context, target);
    }

    initialize(target: string, context: any, defaultValue: any) :void {
        jp.value(context, target, { value: defaultValue, enabled: true, visible: true });
        this.contextTargetHasBeenSet.next({ target: target, value: defaultValue });
    }

    setContextData(target: string, value: any, context: any, fireEvent: boolean = true): void {
        jp.value(context, target, value);
        if (fireEvent) this.contextTargetHasBeenSet.next({ target: target, value: value });
    }
}
